// FetchInvitations.js
import React from 'react';
import { useFetchInvitations } from '../hooks/DataFetching/useFetchInvitations';

export const FetchInvitations = () => {
    const { invitations, loading } = useFetchInvitations();

    const renderInvitationsTable = (invitations) => {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>GroupId</th>
                        <th>UserId</th>
                        <th>Accepted</th>
                        <th>CreatedOn</th>
                    </tr>
                </thead>
                <tbody>
                    {invitations.map(invitation =>
                        <tr key={invitation.id}>
                            <td>{invitation.id}</td>
                            <td>{invitation.groupId}</td>
                            <td>{invitation.userId}</td>
                            <td>{invitation.accepted}</td>
                            <td>{invitation.createdOn}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    let contents = loading ? (
        <p>
            <em>Loading...</em>
        </p>
    ) : renderInvitationsTable(invitations);

    return (
        <div>
            <h1 id="tabelLabel">Invitations</h1>
            <p>This component demonstrates fetching data from the server.</p>
            {contents}
        </div>
    );
};

